import {BusinessKYCDocumentType} from '@/types/BusinessKYCDocumentType';

export const idTypes: {key: string; value: BusinessKYCDocumentType}[] = [
  {key: 'National ID', value: BusinessKYCDocumentType.NationalID},
  {key: 'BVN', value: BusinessKYCDocumentType.BVN},
  {key: 'Driver License', value: BusinessKYCDocumentType.DriverLicense},
  {key: 'Passport', value: BusinessKYCDocumentType.Passport},
];
